/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Go_Offline_ConfirmInputs */



/**
* | output |
* | --- |
* | "Go Offline" |
*
* @param {Offline_Go_Offline_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_go_offline_confirm = /** @type {((inputs?: Offline_Go_Offline_ConfirmInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Go_Offline_ConfirmInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Passer hors ligne")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modo sin conexión")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ficar offline")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai offline")
	return /** @type {LocalizedString} */ ("Go Offline")
});